export const Tacitly = {
  onoff: true, //加密开关 双向加密 备用
  // Base_Port: process.env.NODE_ENV == "development" ? "" : "https://demo.dyuit.cn/xiaoyin/index.php/api/",
  Base_Port:
    process.env.NODE_ENV == "development"
      ? "" : 
       "https://old.xyajglxt.com/index.php/api/", //线下
        // "https://www.xyajglxt.com/index.php/api/", //线上
  key: "ABWE@@#aQWow!@#$", //加密🔑
};
